import React from "react";
import { ASCENDING, DESCENDING, SORT_ASCENDING, SORT_OTHER } from "./constants";
/**
 * A11Y utility to derive Aria-Caption, that is rendered inside table Caption, invisible.
 * A11Y Spec : if the last name column is sorted in ascending order
 * "sorted by last name, ascending" would be added to the caption.
 * Changes by sort will be propagated to table as a caption
 *
 * @param {Object} of ``customStrings`` needed
 * @param {String} newDirection direction of sort after user sort action
 * @param {String} label label of the column being sorted
 */

import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function getSortedStatusUpdates(_ref, ariaCaption, newDirection, label) {
  let {
    sortedBy,
    sortAscending,
    sortDescending
  } = _ref;
  let isLiveRegion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  const isSortedAsc = newDirection === SORT_ASCENDING;
  const direction = isSortedAsc ? ASCENDING : DESCENDING;

  if (isLiveRegion) {
    const liveRegionText = isSortedAsc ? sortAscending : sortDescending;

    if (typeof label !== "string") {
      return _jsxs("span", {
        children: [label, " ", liveRegionText]
      });
    }

    return `${label} ${liveRegionText}`;
  } else if (typeof label !== "string") {
    return _jsxs(React.Fragment, {
      children: [ariaCaption ? `${ariaCaption},` : "", " ", sortedBy, " ", label, " ", `, ${direction}`]
    });
  }

  return ariaCaption ? `${ariaCaption}, ${sortedBy} ${label}, ${direction}` : `${sortedBy} ${label}, ${direction}`;
}
/**
 * A11Y utility to compute sortable table header aria properties
 *
 * @param {Object} of ``customStrings``
 * @param {boolean} isSorted
 * @param {String} direction direction of sort ascending or descending
 */

export function getAriaHeaderProperties(isSorted, direction) {
  const isSortedAsc = direction === SORT_ASCENDING;
  const sortStatus = isSortedAsc ? ASCENDING : DESCENDING;
  return {
    ariaSortStatus: isSorted ? sortStatus : SORT_OTHER
  };
}